import { useEffect, useState } from "react";
import { FaCrown, FaStar } from "react-icons/fa";
import apiClient from "../../utils/axiosPetition";
import Cargando from "../../utils/Cargando";
import BotonUpgradeEpayco from "../ePayco/BotonUpgradeEpayco";
import { useMembership } from "../../context/MembershipContext";

const PassToMember = () => {
    const { isPremium, loading: membershipLoading } = useMembership();
    const [precioUpgrade, setPrecioUpgrade] = useState(null);

    useEffect(() => {
        apiClient.get('/api/precios')
            .then(res => {
                const precio = res.data.find(s => s.nombre === 'Membresía Paciente Premium');
                setPrecioUpgrade(precio?.valor ?? null);
            })
            .catch(() => setPrecioUpgrade(null));
    }, []);

    if (membershipLoading) {
        return <Cargando />;
    }

    if (isPremium()) {
        return (
            <div className="mt-5 mx-auto max-w-lg bg-white p-6 rounded-lg border border-[#6e787aff] text-center">
                <FaCrown className="text-yellow-500 text-4xl mx-auto mb-4" />
                <h2 className="text-2xl font-bold text-[#1f94c2ff] mb-2">
                    Ya eres miembro Premium
                </h2>
                <p className="text-[#70706eff]">
                    Disfruta de todos los beneficios de Redplika.
                </p>
            </div>
        );
    }

    const precioFormateado = precioUpgrade != null
        ? `$${Number(precioUpgrade).toLocaleString('es-CO')}`
        : '...';

    return (
        <div className="mt-5 mx-auto max-w-lg bg-white p-6 rounded-lg border border-[#6e787aff]">
            <div className="text-center mb-6">
                <div className="flex justify-center mb-4">
                    <div className="bg-gradient-to-br from-yellow-400 to-orange-500 p-4 rounded-full shadow-md">
                        <FaCrown className="text-white text-3xl" />
                    </div>
                </div>
                <h2 className="text-2xl font-bold text-[#1f94c2ff]">
                    Membresía Premium de <span className="text-[#f79865ff]">Redplika</span>
                </h2>
                <p className="text-[#70706eff] font-medium mt-4">
                    Activa tu membresía Premium por {precioFormateado} y accede a beneficios exclusivos.
                </p>
            </div>

            <div className="bg-[#f9f9f9] rounded-lg p-4 mb-6 space-y-3">
                <div className="flex items-start gap-3">
                    <FaStar className="text-yellow-500 mt-0.5 shrink-0" />
                    <p className="text-sm text-[#70706eff]">Descuentos exclusivos de aliados estratégicos</p>
                </div>
                <div className="flex items-start gap-3">
                    <FaStar className="text-yellow-500 mt-0.5 shrink-0" />
                    <p className="text-sm text-[#70706eff]">Acceso completo a beneficios y promociones premium</p>
                </div>
            </div>

            <BotonUpgradeEpayco
                className="w-full py-3 bg-gradient-to-r from-yellow-400 via-orange-500 to-yellow-600 text-white font-bold rounded-lg hover:from-yellow-500 hover:via-orange-600 hover:to-yellow-700 transition-all shadow-md text-base"
                disabled={precioUpgrade == null}
            >
                <span className="inline-flex items-center justify-center gap-2">
                    <FaCrown />
                    Pagar {precioFormateado} con ePayco
                </span>
            </BotonUpgradeEpayco>
        </div>
    );
};

export default PassToMember;
